import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Menu, MenuItem, TextField } from '@material-ui/core';
import {
	mdiShieldCheck,
	mdiShieldLinkVariant,
	mdiShieldRemove,
	mdiSquareEditOutline,
	mdiTrashCan,
	mdiFormTextboxPassword,
	mdiDotsVerticalCircleOutline
} from '@mdi/js';
import { ConfirmationRequiredButton, TooltipButton } from '../../../../../widgets';
import { useActions } from '../../store';
import { actions as proxyActions } from '../../../../proxy/proxies/store/proxies';

function AccountActionsRenderer({ value, data }) {
	const account_id = value;
	const username = data.ig_username;
	const actions = useActions();

	const dispatch = useDispatch();
	const [anchorEl, setAnchorEl] = useState(null);

	const handleMenuOpen = event => {
		setAnchorEl(event.currentTarget);
	};

	const handleMenuClose = () => {
		setAnchorEl(null);
	};

	function handleEdit(event) {
		event.stopPropagation();
		event.nativeEvent.stopImmediatePropagation();
		dispatch(
			actions.accounts.displayEditFormAccount({
				visible: true,
				account_id: account_id
			})
		);
	}

	function handleDeleteAccount() {
		dispatch(
			actions.accounts.deleteAccount({
				id: account_id,
				account_id: account_id
			})
		);
	}

	function handlePersistProxy() {
		dispatch(
			proxyActions.persistAccountProxy({
				account_id: account_id,
				account_type: 'ig'
			})
		);
	}

	function handleReassignProxy() {
		dispatch(
			actions.accounts.reassignProxyAccount({
				id: account_id,
				account_id: account_id,
				account_type: 'ig'
			})
		);
	}

	function handleRemoveProxy() {
		dispatch(
			actions.accounts.reassignProxyAccount(
				{ id: account_id, account_id: account_id, account_type: 'ig' },
				{ query: { reassign: false } }
			)
		);
	}

	const [securityCode, setSecurityCode] = useState('');
	function handleSubmitSecurityCode(data) {
		dispatch(
			actions.accounts.submitSecurityCodeAccount({
				id: account_id,
				account_id: account_id,
				security_code: securityCode
			})
		);
	}

	return (
		<span>
			<TooltipButton tooltip="Edit" icon={mdiSquareEditOutline} iconSize={0.75} onClick={handleEdit} />
			<TooltipButton
				tooltip="More Actions"
				icon={mdiDotsVerticalCircleOutline}
				iconSize={0.75}
				onClick={handleMenuOpen}
			/>
			<Menu id="simple-menu" anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleMenuClose}>
				<MenuItem onClick={handleMenuClose}>
					<ConfirmationRequiredButton
						onConfirm={handleDeleteAccount}
						text={"Delete account '" + username + "'?"}
						tooltip="Delete"
						submitLabel="Delete"
						icon={mdiTrashCan}
					/>
				</MenuItem>
				<MenuItem onClick={handleMenuClose}>
					<ConfirmationRequiredButton
						onConfirm={handlePersistProxy}
						text={"Create Proxy from account '" + username + "'?"}
						tooltip="Create Proxy"
						submitLabel="Create Proxy"
						icon={mdiShieldCheck}
					/>
				</MenuItem>
				<MenuItem onClick={handleMenuClose}>
					<ConfirmationRequiredButton
						onConfirm={handleReassignProxy}
						text={"Assign new proxy for account '" + username + "'?"}
						tooltip="Reassign Proxy"
						submitLabel="Reassign Proxy"
						icon={mdiShieldLinkVariant}
					/>
				</MenuItem>
				<MenuItem onClick={handleMenuClose}>
					<ConfirmationRequiredButton
						onConfirm={handleRemoveProxy}
						text={"Remove proxy from account '" + username + "'?"}
						tooltip="Remove Proxy"
						submitLabel="Remove Proxy"
						icon={mdiShieldRemove}
					/>
				</MenuItem>
				<MenuItem onClick={handleMenuClose}>
					<ConfirmationRequiredButton
						onConfirm={handleSubmitSecurityCode}
						text={'Enter Security Code'}
						tooltip="Enter Security Code"
						submitLabel="Submit Security Code"
						icon={mdiFormTextboxPassword}
						childrenComponent={
							<TextField
								id="security-code-input"
								onChange={event => setSecurityCode(event.target.value)}
							/>
						}
					/>
				</MenuItem>
			</Menu>
		</span>
	);
}

export default AccountActionsRenderer;
